module.exports = __webpack_public_path__ + "static/media/img_43.a0f1ede4.png";